var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 17C3.5 9.54416 9.54416 3.5 17 3.5C24.4558 3.5 30.5 9.54416 30.5 17C30.5 24.4558 24.4558 30.5 17 30.5C9.54416 30.5 3.5 24.4558 3.5 17ZM17 0.5C7.8873 0.5 0.5 7.8873 0.5 17C0.5 26.1127 7.8873 33.5 17 33.5C26.1127 33.5 33.5 26.1127 33.5 17C33.5 7.8873 26.1127 0.5 17 0.5ZM8.34375 23.2021H25.4064V20.2021H8.34375V23.2021Z",
    fill: "#FF9100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalIcon);
export default __webpack_public_path__ + "static/media/NormalIcon.f1bf2d0a24d85df99779507809c89aa7.svg";
export { ForwardRef as ReactComponent };